export const categories = [
  {
    slug: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '全球顶级足球赛事，五大联赛、欧冠、世界杯等精彩对决，实时赔率，专业分析。',
    matchCount: 1280,
    imageSeq: 'cat-football',
    events: [
      { id: 'fb-1', league: '英超联赛', home: '曼彻斯特城', away: '阿森纳', time: '2026-08-10 03:00', status: 'upcoming', homeOdds: '1.85', drawOdds: '3.60', awayOdds: '4.20' },
      { id: 'fb-2', league: '西甲联赛', home: '巴塞罗那', away: '皇家马德里', time: '2026-08-11 04:00', status: 'upcoming', homeOdds: '2.10', drawOdds: '3.40', awayOdds: '3.30' },
      { id: 'fb-3', league: '意甲联赛', home: 'AC米兰', away: '尤文图斯', time: '2026-08-12 03:45', status: 'upcoming', homeOdds: '2.30', drawOdds: '3.10', awayOdds: '3.00' },
      { id: 'fb-4', league: '德甲联赛', home: '拜仁慕尼黑', away: '多特蒙德', time: '2026-08-13 00:30', status: 'upcoming', homeOdds: '1.65', drawOdds: '4.00', awayOdds: '4.80' },
      { id: 'fb-5', league: '法甲联赛', home: '巴黎圣日耳曼', away: '马赛', time: '2026-08-14 03:00', status: 'upcoming', homeOdds: '1.40', drawOdds: '4.80', awayOdds: '6.50' },
      { id: 'fb-6', league: '英超联赛', home: '利物浦', away: '切尔西', time: '2026-08-15 00:30', status: 'upcoming', homeOdds: '1.95', drawOdds: '3.50', awayOdds: '3.80' },
    ],
  },
  {
    slug: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲篮球联赛等精彩赛事，实时比分直播，专业篮球数据分析。',
    matchCount: 856,
    imageSeq: 'cat-basketball',
    events: [
      { id: 'bk-1', league: 'NBA', home: '洛杉矶湖人', away: '金州勇士', time: '2026-08-10 10:30', status: 'upcoming', homeOdds: '1.90', drawOdds: '', awayOdds: '1.95' },
      { id: 'bk-2', league: 'NBA', home: '波士顿凯尔特人', away: '密尔沃基雄鹿', time: '2026-08-11 08:00', status: 'upcoming', homeOdds: '1.75', drawOdds: '', awayOdds: '2.15' },
      { id: 'bk-3', league: 'NBA', home: '丹佛掘金', away: '菲尼克斯太阳', time: '2026-08-12 10:00', status: 'upcoming', homeOdds: '1.60', drawOdds: '', awayOdds: '2.40' },
      { id: 'bk-4', league: 'CBA', home: '广东宏远', away: '辽宁飞豹', time: '2026-08-13 19:35', status: 'upcoming', homeOdds: '2.00', drawOdds: '', awayOdds: '1.85' },
      { id: 'bk-5', league: 'NBA', home: '迈阿密热火', away: '纽约尼克斯', time: '2026-08-14 08:30', status: 'upcoming', homeOdds: '1.85', drawOdds: '', awayOdds: '2.00' },
      { id: 'bk-6', league: '欧洲联赛', home: '皇家马德里', away: '巴塞罗那', time: '2026-08-15 03:00', status: 'upcoming', homeOdds: '1.70', drawOdds: '', awayOdds: '2.20' },
    ],
  },
  {
    slug: 'tennis',
    name: '网球',
    icon: 'ri-trophy-line',
    description: '四大满贯、ATP、WTA巡回赛全覆盖，精准比分追踪，丰富网球投注市场。',
    matchCount: 523,
    imageSeq: 'cat-tennis',
    events: [
      { id: 'tn-1', league: 'ATP巡回赛', home: '德约科维奇', away: '阿尔卡拉斯', time: '2026-08-10 20:00', status: 'upcoming', homeOdds: '1.80', drawOdds: '', awayOdds: '2.05' },
      { id: 'tn-2', league: 'WTA巡回赛', home: '斯瓦泰克', away: '萨巴伦卡', time: '2026-08-11 18:00', status: 'upcoming', homeOdds: '1.70', drawOdds: '', awayOdds: '2.20' },
      { id: 'tn-3', league: 'ATP巡回赛', home: '辛纳', away: '梅德韦杰夫', time: '2026-08-12 21:00', status: 'upcoming', homeOdds: '1.55', drawOdds: '', awayOdds: '2.50' },
      { id: 'tn-4', league: 'WTA巡回赛', home: '高芙', away: '莱巴金娜', time: '2026-08-13 17:00', status: 'upcoming', homeOdds: '1.90', drawOdds: '', awayOdds: '1.95' },
    ],
  },
  {
    slug: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: '英雄联盟、DOTA2、CS:GO、王者荣耀等顶级电竞赛事，实时数据追踪，丰富竞猜玩法。',
    matchCount: 942,
    imageSeq: 'cat-esports',
    events: [
      { id: 'es-1', league: 'LPL夏季赛', home: 'JDG', away: 'BLG', time: '2026-08-10 17:00', status: 'upcoming', homeOdds: '2.10', drawOdds: '', awayOdds: '1.75' },
      { id: 'es-2', league: 'LCK夏季赛', home: 'T1', away: 'GEN.G', time: '2026-08-11 16:00', status: 'upcoming', homeOdds: '2.30', drawOdds: '', awayOdds: '1.65' },
      { id: 'es-3', league: 'DOTA2国际邀请赛', home: 'Team Spirit', away: 'PSG.LGD', time: '2026-08-12 19:00', status: 'upcoming', homeOdds: '1.90', drawOdds: '', awayOdds: '1.95' },
      { id: 'es-4', league: 'CS:GO Major', home: 'FaZe Clan', away: 'NAVI', time: '2026-08-13 22:00', status: 'upcoming', homeOdds: '1.85', drawOdds: '', awayOdds: '2.00' },
    ],
  },
  {
    slug: 'baseball',
    name: '棒球',
    icon: 'ri-riding-line',
    description: 'MLB美国职棒大联盟、日职棒等全球顶级棒球赛事，实时数据，专业分析。',
    matchCount: 348,
    imageSeq: 'cat-baseball',
    events: [
      { id: 'bb-1', league: 'MLB', home: '纽约洋基', away: '波士顿红袜', time: '2026-08-10 07:05', status: 'upcoming', homeOdds: '1.85', drawOdds: '', awayOdds: '2.00' },
      { id: 'bb-2', league: 'MLB', home: '洛杉矶道奇', away: '旧金山巨人', time: '2026-08-11 10:10', status: 'upcoming', homeOdds: '1.65', drawOdds: '', awayOdds: '2.30' },
      { id: 'bb-3', league: '日职棒', home: '读卖巨人', away: '阪神虎', time: '2026-08-12 18:00', status: 'upcoming', homeOdds: '1.90', drawOdds: '', awayOdds: '1.95' },
    ],
  },
];

export const featuredEvents = [
  {
    id: 'feat-1',
    category: '足球',
    categorySlug: 'football',
    league: '英超联赛',
    homeTeam: '曼彻斯特城',
    awayTeam: '阿森纳',
    homeLogo: 'ri-shield-star-line',
    awayLogo: 'ri-shield-flash-line',
    time: '2026-08-10 03:00',
    homeOdds: '1.85',
    drawOdds: '3.60',
    awayOdds: '4.20',
    viewers: 128000,
    tag: '热门',
  },
  {
    id: 'feat-2',
    category: '篮球',
    categorySlug: 'basketball',
    league: 'NBA',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeLogo: 'ri-basketball-line',
    awayLogo: 'ri-basketball-fill',
    time: '2026-08-10 10:30',
    homeOdds: '1.90',
    drawOdds: '',
    awayOdds: '1.95',
    viewers: 256000,
    tag: '焦点战',
  },
  {
    id: 'feat-3',
    category: '足球',
    categorySlug: 'football',
    league: '西甲联赛',
    homeTeam: '巴塞罗那',
    awayTeam: '皇家马德里',
    homeLogo: 'ri-football-line',
    awayLogo: 'ri-football-fill',
    time: '2026-08-11 04:00',
    homeOdds: '2.10',
    drawOdds: '3.40',
    awayOdds: '3.30',
    viewers: 389000,
    tag: '国家德比',
  },
  {
    id: 'feat-4',
    category: '电竞',
    categorySlug: 'esports',
    league: 'LPL夏季赛',
    homeTeam: 'JDG',
    awayTeam: 'BLG',
    homeLogo: 'ri-gamepad-line',
    awayLogo: 'ri-gamepad-fill',
    time: '2026-08-10 17:00',
    homeOdds: '2.10',
    drawOdds: '',
    awayOdds: '1.75',
    viewers: 198000,
    tag: '电竞',
  },
];

export const articles = [
  {
    id: 'article-1',
    title: '2026赛季英超联赛争冠形势深度分析：五强争霸谁主沉浮',
    excerpt: '新赛季英超联赛即将拉开帷幕，曼城、阿森纳、利物浦、切尔西和曼联五支豪门球队的阵容变化和备战情况全面解析。',
    category: '足球',
    categorySlug: 'football',
    author: 'bb体育分析师',
    date: '2026-08-06',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20packed%20with%20fans%20under%20dramatic%20stadium%20lights%2C%20green%20pitch%2C%20intense%20match%20atmosphere%2C%20editorial%20sports%20photography%20with%20warm%20golden%20tones%20and%20deep%20shadows&width=800&height=400&seq=article-1&orientation=landscape',
    content: `新赛季英超联赛将在本周末正式拉开帷幕，各大豪门经过夏季转会窗的调整，阵容实力发生了显著变化。本文将为您全面分析五支争冠球队的备战情况。

曼城作为卫冕冠军，在瓜迪奥拉的带领下依旧保持着强大的统治力。夏季转会窗引进了两名实力派中场球员，进一步增强了阵容深度。哈兰德在季前赛中状态火热，新赛季有望继续刷新进球纪录。

阿森纳上赛季表现令人眼前一亮，年轻球员的成长速度超出预期。阿尔特塔打造的战术体系日趋成熟，新赛季他们将是曼城卫冕路上最大的挑战者。

利物浦在克洛普离任后进入了新时代，新任主教练正在打造属于自己的战术风格。球队在转会市场上动作频频，新援融入速度将直接影响球队的争冠前景。

切尔西和曼联在经历了动荡的赛季后，都在夏季进行了大规模调整。两支传统豪门都渴望重返欧冠区，甚至向冠军发起冲击。

从数据角度来看，曼城以1.85的夺冠赔率领跑，阿森纳以3.60紧随其后。新赛季英超的竞争格局将更加开放，每轮比赛都可能影响最终的冠军归属。`,
  },
  {
    id: 'article-2',
    title: 'NBA新赛季前瞻：湖人勇士巅峰对决全解析',
    excerpt: 'NBA新赛季即将开战，詹姆斯领衔的湖人队和库里率领的勇士队将再次上演精彩对决。本文深入分析两队阵容变化和战术调整。',
    category: '篮球',
    categorySlug: 'basketball',
    author: 'bb体育分析师',
    date: '2026-08-05',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20NBA%20basketball%20arena%20with%20players%20in%20action%20on%20the%20court%2C%20bright%20stadium%20lights%2C%20excited%20crowd%2C%20editorial%20sports%20photography%20with%20warm%20contrast%20and%20athletic%20energy&width=800&height=400&seq=article-2&orientation=landscape',
    content: `NBA新赛季的战火即将点燃，洛杉矶湖人和金州勇士这两支西部豪门的对决始终是球迷关注的焦点。

湖人队在休赛期进行了针对性补强，围绕詹姆斯和戴维斯的核心阵容增添了多名优质角色球员。球队在防守端的升级尤为明显，新赛季有望在西部排名中占据有利位置。

勇士队则继续以库里为核心，汤普森伤愈回归后状态稳步提升。科尔教练在季前赛中尝试了多种战术组合，球队的进攻流畅度令人印象深刻。

从历史交锋数据来看，两队最近10次交手各胜5场，实力旗鼓相当。新赛季的首场对决定于8月10日，届时将在洛杉矶斯台普斯中心上演。

本场焦点战中，湖人以1.90的赔率略占优势，勇士以1.95紧随其后。这场比赛不仅关乎两队的赛季开局，更将对西部格局产生重要影响。`,
  },
  {
    id: 'article-3',
    title: '电子竞技崛起：2026全球电竞产业趋势报告',
    excerpt: '电子竞技产业持续高速增长，全球观众突破8亿。本文从赛事规模、商业价值和选手生态三个维度分析电竞产业最新趋势。',
    category: '电竞',
    categorySlug: 'esports',
    author: 'bb体育分析师',
    date: '2026-08-04',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20gaming%20arena%20with%20large%20LED%20screens%20displaying%20game%20action%2C%20professional%20gaming%20setup%2C%20neon%20accent%20lighting%2C%20packed%20audience%2C%20editorial%20photography%20with%20cyberpunk%20atmosphere&width=800&height=400&seq=article-3&orientation=landscape',
    content: `电子竞技产业在过去几年中经历了爆发式增长，2026年全球电竞观众数量已突破8亿大关。这一数字甚至超过了许多传统体育项目的全球观众规模。

从赛事规模来看，英雄联盟全球总决赛的收视人数已接近超级碗水平，DOTA2国际邀请赛的奖金池屡创新高。各大游戏厂商也在积极布局电竞赛事生态，形成了完整的产业链。

商业价值方面，全球电竞市场收入预计在2026年将突破200亿美元。越来越多的传统体育俱乐部和品牌赞助商开始涉足电竞领域，跨界合作成为新常态。

在选手生态上，职业电竞选手的收入水平和社会认可度不断提升。各国政府也开始重视电竞人才培养，多个国家已将电竞纳入正式体育项目。

bb体育作为专业的体育竞技平台，全面覆盖了包括英雄联盟、DOTA2、CS:GO、王者荣耀在内的主流电竞赛事，为用户提供实时数据追踪和丰富的竞猜玩法。`,
  },
  {
    id: 'article-4',
    title: '网球四大满贯赛程解析：2026赛季不容错过的精彩对决',
    excerpt: '2026年网球四大满贯赛事时间表及看点前瞻，德约科维奇能否再创纪录，新生代选手的挑战之路。',
    category: '网球',
    categorySlug: 'tennis',
    author: 'bb体育分析师',
    date: '2026-08-03',
    readTime: '5分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20court%20with%20player%20serving%20under%20bright%20sunlight%2C%20grand%20slam%20stadium%20atmosphere%2C%20clay%20court%20texture%2C%20editorial%20sports%20photography%20with%20soft%20natural%20light%20and%20clean%20composition&width=800&height=400&seq=article-4&orientation=landscape',
    content: `2026赛季网球四大满贯赛事的争夺即将全面展开。从澳网到美网，每一站大满贯都承载着选手们的梦想和荣誉。

德约科维奇在去年继续扩大着自己的大满贯冠军数量，新赛季他将面临来自阿尔卡拉斯、辛纳等新生代选手的强烈挑战。ATP排名榜上的竞争从未如此激烈。

女子网坛同样精彩纷呈，斯瓦泰克的统治力依旧，但萨巴伦卡、高芙等选手的快速成长让竞争格局变得更加开放。

bb体育为您提供全方位的网球赛事覆盖，从大满贯到ATP/WTA巡回赛，实时比分更新和专业数据分析帮助您更好地把握比赛走向。

新赛季首站大满贯——澳大利亚网球公开赛将于1月中旬在墨尔本公园打响，届时全球顶尖选手将齐聚一堂，为年度首个大满贯冠军展开激烈争夺。`,
  },
  {
    id: 'article-5',
    title: '体育竞猜入门指南：新手必知的五大核心策略',
    excerpt: '从零开始了解体育竞猜，掌握资金管理、数据分析、价值投注等五大核心策略，理性参与体育竞技娱乐。',
    category: '足球',
    categorySlug: 'football',
    author: 'bb体育编辑',
    date: '2026-08-02',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20sports%20analytics%20dashboard%20on%20a%20sleek%20monitor%20displaying%20match%20statistics%20and%20data%20visualization%2C%20professional%20office%20setting%20with%20warm%20ambient%20lighting%2C%20clean%20minimal%20aesthetic&width=800&height=400&seq=article-5&orientation=landscape',
    content: `对于刚刚接触体育竞猜的新手来说，掌握正确的方法和策略至关重要。本文将为您介绍五大核心策略，帮助您更加理性地参与体育竞技娱乐。

策略一：资金管理。制定合理的预算计划，永远不要使用超出自己承受能力的资金。建议将每次投入控制在总预算的1%-5%之间。

策略二：数据驱动决策。在做出选择之前，充分收集和分析相关数据，包括球队近期状态、交锋历史、伤病情况、主客场表现等。

策略三：专注熟悉领域。选择自己最熟悉的体育项目和联赛，深入了解球队和球员的特点，形成自己的分析框架。

策略四：价值投注思维。不要仅仅关注热门选项，学会寻找被市场低估的机会，这需要长期的积累和学习。

策略五：情绪管理。保持冷静理性的心态，不因连续成功而盲目自信，也不因暂时失利而冲动决策。

bb体育平台提供专业的数据分析工具和实时信息更新，帮助您做出更明智的决策。记住，理性参与，享受比赛本身的乐趣才是最重要的。`,
  },
  {
    id: 'article-6',
    title: '2026赛季法甲联赛：大巴黎王朝能否延续',
    excerpt: '巴黎圣日耳曼在法甲联赛中的统治地位面临挑战，马赛、摩纳哥等球队的崛起让新赛季充满悬念。',
    category: '足球',
    categorySlug: 'football',
    author: 'bb体育分析师',
    date: '2026-08-01',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=French%20football%20stadium%20with%20Paris%20skyline%20in%20background%20during%20sunset%2C%20dramatic%20golden%20hour%20lighting%2C%20soccer%20match%20atmosphere%2C%20editorial%20sports%20photography%20with%20warm%20romantic%20tones&width=800&height=400&seq=article-6&orientation=landscape',
    content: `巴黎圣日耳曼在过去几个赛季中统治了法甲联赛，但新赛季的竞争格局正在发生变化。

马赛在夏季转会窗进行了大规模引援，球队整体实力大幅提升。摩纳哥延续了培养年轻球员的传统，多名新星在季前赛中表现出色。

里昂和里尔等传统强队也在积极调整，法甲联赛的整体竞争水平正在提升。大巴黎虽然依旧拥有联赛最强的纸面实力，但其他球队的崛起让冠军之争变得更加有趣。

从竞猜角度分析，大巴黎的夺冠赔率虽然仍是最低的1.40，但相比前几个赛季略有上升，反映出市场对竞争加剧的预期。新赛季法甲联赛值得期待。`,
  },
];

export const faqData = [
  {
    question: 'bb体育平台是否安全可靠？',
    answer: 'bb体育平台持有合法运营牌照，采用国际领先的加密技术保护用户数据和资金安全。平台运营多年，已为数百万用户提供稳定可靠的服务，是值得信赖的体育竞技娱乐平台。',
  },
  {
    question: '如何在bb体育注册账号？',
    answer: '注册bb体育账号非常简单，只需点击页面右上角的"注册"按钮，填写基本信息并完成手机号或邮箱验证，即可在3分钟内完成注册。新用户注册即享专属优惠福利。',
  },
  {
    question: 'bb体育支持哪些体育赛事？',
    answer: 'bb体育覆盖全球超过30个体育项目的赛事，包括足球、篮球、网球、棒球、冰球、排球、乒乓球、羽毛球、电竞等。涵盖英超、西甲、NBA、欧冠等全部顶级联赛。',
  },
  {
    question: '如何查看实时比分和赛事直播？',
    answer: '登录bb体育平台后，在"赛事直播"板块即可查看所有正在进行和即将开始的赛事。我们提供实时比分更新、文字直播和部分赛事的视频直播服务，让您不错过任何精彩瞬间。',
  },
  {
    question: '平台支持哪些充值方式？',
    answer: 'bb体育支持多种安全便捷的充值方式，包括银行卡转账、微信支付、支付宝、USDT数字货币等。充值实时到账，无手续费，最低充值额度为100元。',
  },
  {
    question: '提现需要多长时间？',
    answer: 'bb体育提供快速提现服务，大多数提现申请在30分钟内处理完毕。首次提现需要进行身份验证以确保资金安全，验证通过后即可享受极速提现体验。',
  },
];

export const promotions = [
  {
    id: 'promo-1',
    title: '新用户注册大礼包',
    description: '首次注册即送288元体验金，完成首笔充值再享100%返还优惠，最高可达1888元。',
    icon: 'ri-gift-2-line',
    tag: '限时',
  },
  {
    id: 'promo-2',
    title: '每日签到领积分',
    description: '每日登录签到领取积分奖励，连续签到7天额外获得神秘大礼。积分可兑换投注金和精美礼品。',
    icon: 'ri-calendar-check-line',
    tag: '每日',
  },
  {
    id: 'promo-3',
    title: '推荐好友共赢',
    description: '邀请好友注册并完成首笔充值，双方各得88元奖励。推荐越多奖励越丰厚，上不封顶。',
    icon: 'ri-user-heart-line',
    tag: '热门',
  },
  {
    id: 'promo-4',
    title: 'VIP会员专属特权',
    description: '成为VIP会员享受更高返水比例、专属客服、优先提现、生日礼包等多项尊贵权益。',
    icon: 'ri-vip-crown-line',
    tag: '专属',
  },
];

export const trustBadges = [
  { icon: 'ri-shield-check-line', title: '合法运营', description: '持有正规牌照' },
  { icon: 'ri-lock-line', title: '数据加密', description: 'SSL安全传输' },
  { icon: 'ri-customer-service-2-line', title: '客服支持', description: '7×24小时在线' },
  { icon: 'ri-verified-badge-line', title: '公平公正', description: '第三方监管' },
];